import React, { FC } from "react";
import styled from "styled-components";

import useDoubleClick from "../../hooks/useDoubleClick/useDoubleClick";
import { usePlayerStore } from "../../store/usePlayerStore";

const OverlayArea = styled.div<{
  isMobile: boolean;
}>`
  height: auto;
  inset: 56px 0 ${({ isMobile }) => (isMobile ? 0 : 56)}px; /* top left/right bottom */
  position: absolute;

  &,
  &:focus {
    outline: none !important;
  }
`;

interface Props {
  onClick: () => unknown;
  onDoubleClick?: () => unknown;
}

export const OverlayControls: FC<Props> = ({ onClick, onDoubleClick }) => {
  const { useStoreState } = usePlayerStore();
  const device = useStoreState.device();
  return (
    <OverlayArea
      isMobile={device.isMobile}
      onClick={useDoubleClick({
        doubleClickDelay: 300,
        onClick,
        onDoubleClick
      })}
    />
  );
};
